import React, { FC, useState, useRef } from 'react'
import { observer } from 'mobx-react'
import { IonSpinner, IonHeader, IonModal, IonContent } from '@ionic/react'
import { Input } from '@cps'
import { discountMobx } from 'restaurant'
import { memberMobx } from '@mobx/mkt'
import { modalLayer, toastLayer } from '@utils'
import { payPlanMobx } from '@mobxStore'
import { GiftCardAmountModal } from '../../modal'
import './index.scss'

interface IProps {
  selectedCard: IMutBankCardInfo;
  resolve?: () => void;
  reject?: () => void;
  isForbidGiftCard?: boolean;
}

const AddGiftCar: FC<IProps> = ({ resolve, reject, isForbidGiftCard = false }) => {
  const modalRef = useRef<any>()

  const [value, setValue] = useState('')
  const [loading, setLoading] = useState(false)

  return (
    <IonModal
      isOpen
      cssClass='gift-card-auth-modal'
      onDidDismiss={reject}
    >
      <IonHeader>
        <div className='gift-card-auth-header'>
          <span>{i18n.t('pay.useGiftCard')}</span>
          <i className='iconfont icon-close' data-cypid='giftCardAuthModalClose' onClick={reject} />
        </div>

      </IonHeader>
      <IonContent>
        <div className='gift-code-input-bar'>
          <div className='code-input-bar'>
            <Input
              data-cypid='giftCardAuthModalInput'
              autoFocus
              onChange={(e) => {
                setValue(e.target.value)
              }}
              id='context'
              value={value}
              placeholder={isForbidGiftCard ? i18n.t('checkout.input_promocode') : i18n.t('checkout.input_giftcard')}
              onBlur={(e) => {
                const upperCaseValue = e.target.value.toLocaleUpperCase()
                setValue(upperCaseValue)
              }}
            />
            <span
              data-cypid='giftCardAuthModalConfirm'
              onClick={async () => {
                if (value && value.length >= 6) {
                  if (await discountMobx.verifyPromoCode(value)) {
                    const exitCodes = discountMobx.discountAction.promoCodes
                    discountMobx.setPromoCodes([...exitCodes, value])
                    toastLayer.success(i18n.t('checkout.promocode_use_success_need_check'))
                    setValue('')
                  } else if (!isForbidGiftCard) {
                    setLoading(true)
                    try {
                      const card = await memberMobx.checkoutAddGiftCard(value)
                      console.log(card)
                      const amount = await modalLayer<{ card: IMemberGiftCardInfo }, number>(GiftCardAmountModal, { card }, 'giftCardAmountModal')
                      payPlanMobx.addCacheGiftCardShowList([card])
                      payPlanMobx.setGiftCardPayAmount(card, amount)
                      setValue('')
                      reject()
                    } catch (e) {
                      if (e && e.message) {
                        toastLayer.error({
                          content: e.message,
                          duration: 1000,
                        })
                      }
                    } finally {
                      setLoading(false)
                    }
                  }
                }
              }}
              className={value.length >= 6 ? 'actived' : ''}
            >
              {loading ? <IonSpinner /> : i18n.t('mkt.giftCard.determineBinding')}
            </span>
          </div>

        </div>

      </IonContent>
    </IonModal>
  )
}

export default observer(AddGiftCar)
